import { parseSafePageNumber } from '@shared/utils/parse-safe-page-number';

export interface ParsedJobsPage {
  page: number;
  filterSlugs: string[];
}

const NUMBER_REGEX = /^\d+$/;

const toSlugsArray = (slugs: string | string[] | undefined): string[] => {
  if (Array.isArray(slugs)) return slugs;
  return slugs ? [slugs] : [];
};

export const parseJobsPageFromSlugs = (slugs: string | string[] | undefined): ParsedJobsPage => {
  const segments = toSlugsArray(slugs).filter(Boolean);
  const last = segments.at(-1);

  if (last !== undefined && NUMBER_REGEX.test(last)) {
    const page = parseSafePageNumber(last);
    return { page: page ?? 1, filterSlugs: segments.slice(0, -1) };
  }

  return { page: 1, filterSlugs: segments };
};
